module.exports = __webpack_public_path__ + "static/media/Visa.9ea78eb8.svg";